import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=39c30573&scoped=true"
import script from "./TabsBar.vue?vue&type=script&lang=js"
export * from "./TabsBar.vue?vue&type=script&lang=js"
import style0 from "./TabsBar.vue?vue&type=style&index=0&lang=css"
import style1 from "./TabsBar.vue?vue&type=style&index=1&id=39c30573&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c30573",
  null
  
)

export default component.exports